<m-panel
  shadow="true"
  :border="true"
  :padding="false"
  class="inscription-offre-cours-panel"
>
  <h4 slot="header">
    <span v-html="$i18next.t('modules.inscription-lieu-examen.form.InscriptionOffreCoursPanel.title', inscriptionOffreCours)" />
    <span v-html="inscriptionOffreCours.titreCours" />
  </h4>
  <template v-for="inscriptionLieuExamen in inscriptionLieuExamenList">
    <inscription-lieu-examen-form
      :ref="REF_INSCRIPTION_LIEU_EXAMEN_FORM"
      :inscription-lieu-examen="inscriptionLieuExamen"
    />
  </template>
</m-panel>